import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  padding: 10px;

  div {
    text-align: center;
  }
`

export const ContainerContent = styled.div`
  display: flex;

  flex-direction: column;
`

export const Title = styled.h3`
  font-family: Inter, Roboto, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 130%;
  color: #2d3a40;
`
export const Subtitle = styled.span`
  font-family: Inter, Roboto, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #6d787d;
`
